module.exports = __webpack_public_path__ + "system/static/img/logo_no_data.df4e25d8.png";